// Client-side login rate limiter using localStorage
// Locks out after MAX_ATTEMPTS failed attempts for LOCKOUT_MINUTES
const MAX_ATTEMPTS = 5;
const LOCKOUT_MINUTES = 15;

function getKey(portalType) {
  return `login_attempts_${portalType}`;
}

function getAttemptData(portalType) {
  try {
    const raw = localStorage.getItem(getKey(portalType));
    if (!raw) return { count: 0, firstAttempt: null, lockedUntil: null };
    return JSON.parse(raw);
  } catch {
    return { count: 0, firstAttempt: null, lockedUntil: null };
  }
}

function setAttemptData(portalType, data) {
  localStorage.setItem(getKey(portalType), JSON.stringify(data));
}

/**
 * Check if the user is currently locked out.
 * Returns { locked: boolean, remainingMinutes: number }
 */
export function checkLockout(portalType) {
  const data = getAttemptData(portalType);
  if (data.lockedUntil) {
    const remaining = new Date(data.lockedUntil) - new Date();
    if (remaining > 0) {
      return { locked: true, remainingMinutes: Math.ceil(remaining / 60000) };
    }
    // Lockout expired — reset
    setAttemptData(portalType, { count: 0, firstAttempt: null, lockedUntil: null });
  }
  return { locked: false, remainingMinutes: 0 };
}

/**
 * Record a failed login attempt. Returns { locked, remainingMinutes } if now locked out.
 */
export function recordFailedAttempt(portalType) {
  const data = getAttemptData(portalType);
  const now = new Date();

  // Reset if the window has passed (older than lockout period)
  if (data.firstAttempt) {
    const elapsed = now - new Date(data.firstAttempt);
    if (elapsed > LOCKOUT_MINUTES * 60000) {
      data.count = 0;
      data.firstAttempt = null;
    }
  }

  data.count += 1;
  if (!data.firstAttempt) data.firstAttempt = now.toISOString();

  if (data.count >= MAX_ATTEMPTS) {
    data.lockedUntil = new Date(now.getTime() + LOCKOUT_MINUTES * 60000).toISOString();
    setAttemptData(portalType, data);
    return { locked: true, remainingMinutes: LOCKOUT_MINUTES };
  }

  setAttemptData(portalType, data);
  return { locked: false, attemptsRemaining: MAX_ATTEMPTS - data.count };
}

/**
 * Clear attempts on successful login.
 */
export function clearAttempts(portalType) {
  localStorage.removeItem(getKey(portalType));
}
